import { format, utcToZonedTime } from 'date-fns-tz';
import { ClinicOfficeHourSelectionFragment } from 'shared/types/graphql';

const weekdays: ReadonlyArray<string> = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

type Hours = {
  sunday: string;
  monday: string;
  tuesday: string;
  wednesday: string;
  thursday: string;
  friday: string;
  saturday: string;
};

export const officeHoursDisplay = (
  officeHours: ClinicOfficeHourSelectionFragment[] | null | undefined,
  timeZone: string | null | undefined,
): Hours => {
  const hours: Hours = {
    sunday: 'Closed',
    monday: 'Closed',
    tuesday: 'Closed',
    wednesday: 'Closed',
    thursday: 'Closed',
    friday: 'Closed',
    saturday: 'Closed',
  };

  const tz = { timeZone: timeZone || 'America/Chicago' };

  officeHours?.forEach((officeHour) => {
    const openHour = format(utcToZonedTime(officeHour.openAt, tz.timeZone), 'h:mmaaa', tz);
    const closedHour = format(utcToZonedTime(officeHour.closeAt, tz.timeZone), 'h:mmaaa', tz);
    const day = weekdays[officeHour.dayOfWeek] as keyof Hours;
    hours[day] = !officeHour.isEnabled
      ? 'Closed'
      : officeHour.isOpenTwentyFourHours
      ? '24 Hours'
      : `${openHour}-${closedHour}`;
  });

  return hours;
};
